import {BasicController} from "./BasicController";
import {BasicSmartfoxConstants} from "./BasicSmartfoxConstants";
import {EnvGlobalsHandler} from "../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../IEnvironmentGlobals";
import {ExternalInterfaceController} from "./externalInterface/ExternalInterfaceController";
import {JavascriptCallSetCashHashFactory} from "./externalInterface/vo/JavascriptCallSetCashHashFactory";
import {BasicPaymentEvent} from "../event/BasicPaymentEvent";
import {BasicModel} from "../model/BasicModel";
import {Timer} from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";

import TimerEvent = createjs.TimerEvent;
const logger = getLogger("CoreJS.PaymentHashRefresher");
/**
 * Ensures that the client's payment hash is always valid for some time, if used to open the payment shop in any moment.
 * <p>
 *     To do so, it requests a new one from the server in a certain interval.
 * </p>
 */
export class PaymentHashRefresher {
    private PAYMENT_HASH_EXPIRATION_TIME: number = 900000; // 15 minutes
    private PAYMENT_HASH_REQUEST_TIMEOUT: number = 30000; // 30 seconds

    private isRunning: boolean = false;
    private isWaitingForResponse: boolean = false;
    private hashExpirationTimer: Timer = new Timer(this.PAYMENT_HASH_EXPIRATION_TIME, 1);
    private requestTimeoutTimer: Timer = new Timer(this.PAYMENT_HASH_REQUEST_TIMEOUT, 1);

    public stopRefreshing(): void {
        this.isRunning = false;
        BasicController.getInstance().removeEventListener(BasicPaymentEvent.PAYMENT_HASH_CHANGED, this.bindFunction(this.onHashChanged))
        this.hashExpirationTimer.stop();
    }

    public resetAndStartRefreshing(): void {
        this.stopRefreshing();
        this.startRefreshing();
    }

    public startRefreshing(): void {
        if (!this.isRunning) {
            this.isRunning = true;
            BasicController.getInstance().addEventListener(BasicPaymentEvent.PAYMENT_HASH_CHANGED, this.bindFunction(this.onHashChanged));

            this.requestNewHash();
        }
    }

    private resetAndStartExpirationTimer(): void {
        if (this.env.useShortPaymentHashValidity && this.isRunning) {
            this.hashExpirationTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onHashExpired));
            this.hashExpirationTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onHashExpired));
            this.hashExpirationTimer.reset();
            this.hashExpirationTimer.start();
        }
    }

    private requestNewHash(): void {
        this.isWaitingForResponse = true;
        this.requestTimeoutTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onResponseTimeout));
        this.requestTimeoutTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onResponseTimeout));
        this.requestTimeoutTimer.reset();
        this.requestTimeoutTimer.start();
        BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_NEW_CASH_HASH, []);
    }

    private onHashExpired(event: TimerEvent): void {
        if (this.isRunning) {
            this.requestNewHash();
        }
    }

    private onResponseTimeout(event: TimerEvent): void {
        if (this.isWaitingForResponse) {
            logger.info("response timeout, requesting again…");
            this.requestNewHash();
        }
    }

    private onHashChanged(event: BasicPaymentEvent): void {
        if (this.isWaitingForResponse) {
            this.isWaitingForResponse = false;
            this.requestTimeoutTimer.stop();
            ExternalInterfaceController.instance.executeJavaScriptFunction(new JavascriptCallSetCashHashFactory());
        }
        this.resetAndStartExpirationTimer();
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

}

